import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { transformations } from '../data/content';
export function Transformation() {
  return <section className="w-full bg-white py-16 sm:py-24" aria-labelledby="transformation-title" data-id="element-226" data-mp="mme7x8dofaxh">
      <div className="mx-auto max-w-5xl px-6" data-id="element-227" data-mp="rkz8j8wubwmg">
        <h2 id="transformation-title" className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-navy-deep sm:text-4xl" data-id="element-228" data-mp="rm0nvpkw359z">
          What Your Family Gains — And What Risk They No Longer Face.
        </h2>

        <div className="mt-12 space-y-5" data-id="element-229" data-mp="169vff2n5v3lh">
          {transformations.map((item, index) => <motion.article key={item.before} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.06,
          ease: 'easeOut'
        }} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-7" data-id="element-230" data-mp="1abyr9sdqsa7a" data-mpi={index}>
              <div className="flex items-start gap-4" data-id="element-231" data-mp="176nty1oqzb25">
                <span className="text-2xl" aria-hidden="true" data-id="element-232" data-mp="1791o88blsj8n">
                  {item.emoji}
                </span>
                <div className="grid flex-1 gap-4 sm:grid-cols-2" data-id="element-233" data-mp="y68w62ulk3hr">
                  <div className="rounded-xl border border-slate-200 bg-slate-50 p-5" data-id="element-234" data-mp="y83f5bmb5lj7">
                    <p className="text-xs font-bold uppercase tracking-[0.16em] text-red-600" data-id="element-235" data-mp="1uw00suwlr71a">
                      Before
                    </p>
                    <p className="mt-2 leading-relaxed text-ink/70" data-id="element-236" data-mp="1m3y1x126lyt4">{item.before}</p>
                  </div>
                  <div className="relative rounded-xl border border-trust/30 bg-trust/[0.06] p-5" data-id="element-237" data-mp="1h5mt8tnmhuch">
                    <span className="absolute -left-3 top-1/2 hidden h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full bg-trust text-white sm:flex" aria-hidden="true" data-id="element-238" data-mp="2el0oygvnncrl">
                      <ArrowRightIcon className="h-3.5 w-3.5" data-id="element-239" data-mp="2sqsutgvx7h44" />
                    </span>
                    <p className="text-xs font-bold uppercase tracking-[0.16em] text-trust-dark" data-id="element-240" data-mp="2xom26d8ymh5z">
                      After
                    </p>
                    <p className="mt-2 font-medium leading-relaxed text-navy-deep" data-id="element-241" data-mp="2nz2ix6hc4lal">{item.after}</p>
                  </div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}